const mutations = {
  INIT_ALL_SETTINGS(state, data) {
    state.allSettingsData = null;
    state.allSettingsData = data;
  },

  SET_MAIN_CATEGORY(state, category) {
    state.local.mainCategory = category;
  },

  SET_MAIN_SUB_CATEGORIES(state, subCategoriesArr) {
    state.local.mainSubCategories = Array.from(subCategoriesArr);
  },

  SET_SECONDARY_CATEGORY(state, category) {
    state.local.secondaryCategory = category;
    state.local.secondaryCatSelected = true;
    if (category === -1 || category == undefined) {
      state.local.secondaryCatSelected = false;
    }
  },

  SET_SECONDARY_SUB_CATEGORIES(state, subCategoriesArr) {
    state.local.secondarySubCategories = Array.from(subCategoriesArr);
  },

  SET_LOCATIONS(state, locations) {
    state.local.locations = locations;
  },
  SET_ZONES(state, zonesArr) {
    if (zonesArr) state.local.zones = Array.from(zonesArr);
  },

  SET_SCOPE(state, scopesArr) {
    state.local.scopes = Array.from(scopesArr);
  },

  SET_EXPERIENCE(state, experienceArr) {
    state.local.experience = Array.from(experienceArr);
  },

  SET_MAILING(state, boolVal) {
    state.local.allowMailing = boolVal;
  },

  SET_MAILING_PREFERENCES(state, mailingFrequency) {
    state.local.mailing = mailingFrequency;
  },
  SET_ALERTS_TYPES(state, alertsType) {
    state.local.alertsType = alertsType;
  },

  SET_KEYWORDS_JD(state, keywordsArr) {
    state.local.keywordsJD = keywordsArr;
  },

  INITIALIZE(state) {
    state.local.initialized = true;
  },

  INIT_REMOVE_DATA(state, data) {
    state.removeData = data;
  },

  SET_REASON(state, reasonCode) {
    state.local.reason = reasonCode;
  },

  SET_DESIRED_MAILING(state, code) {
    state.local.toManyEmails = code;
  },

  SET_COMPANY_NAME(state, companyName) {
    state.local.companyName = companyName;
  },

  SET_DESCRIPTION(state, description) {
    state.local.description = description;
  },
  RESET_LOCAL_STATE(state) {
    state.local = {
      mainCategory: null,
      mainSubCategories: undefined,
      secondaryCategory: null,
      locations: {},
      secondarySubCategories: undefined,
      secondaryCatSelected: undefined,
      zones: undefined,
      scopes: undefined,
      experience: null,
      mailing: 1,
      keywordsJD: null,
      allowMailing: true,
      initialized: false,
      reason: null,
      companyName: null,
      companyCode: null,
      tooManyEmails: null,
      description: null
    };
  }
};

export default mutations;
